import * as React from 'react';

import { useTheme } from '../../../../../../theme';

import { SelectedOrderServiceStatus } from '@entities/order';
import { CardExtraSummaryNotification } from '../CardExtraSummaryNotification';

const VISIBLE_NOTIFICATION_STATUSES: SelectedOrderServiceStatus[] = ['requested', 'unconfirmed'];

interface Props {
	icon?: React.ReactNode;
	status?: SelectedOrderServiceStatus;
	segmentLabel?: string;
	travellerLabel?: string;
}

const CardExtraSummaryGroup: React.FC<Props> = ({ icon, status, segmentLabel, travellerLabel, children }) => {
	const { CardExtraSummaryGroup: theme } = useTheme('Shared').CardExtraView;

	return (
		<div className={theme.root}>
			{(icon || travellerLabel || segmentLabel) && (
				<div className={theme.header}>
					{(icon || travellerLabel) && (
						<div className={theme.label}>
							{icon}
							<span>{travellerLabel}</span>
						</div>
					)}
					{segmentLabel && <span className={theme.label}>{segmentLabel}</span>}
				</div>
			)}
			{children}

			{VISIBLE_NOTIFICATION_STATUSES.includes(status) && <CardExtraSummaryNotification status={status} />}
		</div>
	);
};

export default CardExtraSummaryGroup;
